import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/main.css'
import Vue3Lottie from 'vue3-lottie'
import vSelect from 'vue-select'


createApp(App).use(store).use(Vue3Lottie).use(router).component('v-select', vSelect).mount('#app')
